import { render } from "./FilteringDataDisplay.vue?vue&type=template&id=5dc3dc3d&ts=true"
import script from "./FilteringDataDisplay.vue?vue&type=script&lang=ts"
export * from "./FilteringDataDisplay.vue?vue&type=script&lang=ts"

import "./FilteringDataDisplay.vue?vue&type=style&index=0&id=5dc3dc3d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QTable,QInnerLoading,QSpinner});
